export const autosaveKeys = {
  all: ['autosave'] as const,
  lists: () => [...autosaveKeys.all, 'list'] as const,
  list: (params: Record<string, any> = {}) =>
    [...autosaveKeys.lists(), params] as const,
  key: (key: string) => [...autosaveKeys.all, key] as const,
};
